import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface BaseAccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  key: string | number;
  sx?: object;
}

const BaseAccordion: React.FC<BaseAccordionProps> = ({
  title,
  key,
  children,
  sx,
}) => {
  return (
    <Accordion sx={sx || {}}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${key}-content`}
        id={`panel${key}-header`}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default BaseAccordion;
